import { render, staticRenderFns } from "./SettingVendorTermsOfService.vue?vue&type=template&id=058043de"
import script from "./SettingVendorTermsOfService.vue?vue&type=script&lang=js"
export * from "./SettingVendorTermsOfService.vue?vue&type=script&lang=js"
import style0 from "./SettingVendorTermsOfService.vue?vue&type=style&index=0&id=058043de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports